module.exports = __webpack_public_path__ + "static/media/icon-show.f5bc1a9d.svg";